import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { useMediaQuery } from "react-responsive";
import { useDashboardData } from "../../hooks/useDashboardData";

import Header from "../../components/header/Header";
import Sidebar from "../../components/sidebar/Sidebar";

import RankingCard from "../../components/dashboard/RankingCard";
import StatsGrid from "../../components/dashboard/StatsGrid";
import RatingsCard from "../../components/dashboard/RatingsCard";
import VisitorsAreaChart from "../../components/dashboard/VisitorsAreaChart";
import VisibilityPieChart from "../../components/dashboard/VisibilityPieChart";

const SkeletonCard = () => (
  <div className="analysis-card skeleton">
    <div className="skeleton-title" />
    <div className="skeleton-chart" />
  </div>
);

const AcademyHome = () => {
  const { user } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const isSmallMobile = useMediaQuery({ maxWidth: 820 });

  const userName = user?.academyName || `${user?.firstName} ${user?.lastName}` || "John Doe";

  const currentUserId = user?._id;

  const { 
    stats, 
    visitorsData, 
    pieData, 
    rankings, 
    ratings, 
    isLoading, 
    error 
  } = useDashboardData(currentUserId);

  return (
    <div className="tutors-app">
      <Header 
        notificationCount={0} 
        onMenuToggle={() => setSidebarOpen(!sidebarOpen)} 
      />
      <Sidebar 
        isOpen={sidebarOpen} 
        onToggle={() => setSidebarOpen(!sidebarOpen)} 
      />

      <main className="tutors-main">
        <div className="content-container">
          <h1>Welcome, {userName}</h1>
          <p>Track your account activity here.</p>

          {isSmallMobile ? (
            <div className="mobile-stack">
              <StatsGrid stats={stats} />
              {isLoading ? <SkeletonCard /> : <VisitorsAreaChart data={visitorsData} />}
              {isLoading ? <SkeletonCard /> : <VisibilityPieChart data={pieData} />}
              <RankingCard title="Tutor Leaderboard Ranking" rankings={rankings} />
              {isLoading ? <SkeletonCard /> : <RatingsCard ratings={ratings} />}
            </div>
          ) : (
            <>
              <div className="top-section">
                <RankingCard title="Tutor Leaderboard Ranking" rankings={rankings} />
                <div className="right-dashboard">
                  <StatsGrid stats={stats} />
                </div>
              </div>

              <div className="bottom-charts">
                {isLoading ? <SkeletonCard /> : <VisitorsAreaChart data={visitorsData} />}
                {isLoading ? <SkeletonCard /> : <VisibilityPieChart data={pieData} />}
              </div>

              {isLoading ? <SkeletonCard /> : <RatingsCard ratings={ratings} />}
            </>
          )}

          {error && <p className="error-text">Failed to load ratings. Please try again later.</p>}
        </div>
      </main>
      
    </div>
  );
};

export default AcademyHome;